<style>
    /* Define grid areas */
    .grid .header  { grid-area: header;  }
    .grid .side    { grid-area: sidebar;  }
    .grid .main    { grid-area: main;    }

    .grid {
        background: url('/pattern1.png') 0px 0px repeat, linear-gradient(-45deg, rgb(230, 92, 230), rgb(122, 82, 204) 100%);

        display: grid;
        grid-template-areas: "sidebar header "
                             "sidebar main   ";

        grid-template-columns: 300px 1fr;

        grid-template-rows: 40px 
                            1fr;

        min-height: 100vh;
    }

    .grid.dpo {
        background: url('/pattern1.png') 0px 0px repeat, linear-gradient(-45deg, rgb(5, 241, 5), rgb(28, 110, 3) 100%);
    }
    
    main {
		position: relative;
		padding: 2em;
		box-sizing: border-box;
    }

    section.side {
        background: rgba(0,0,0,0.15);
    }
</style>

<script>
    import { Router, Route } from "svelte-routing"
    import { dpo }     from './shared/stores.js'
    import TopMenu     from './TopMenu.svelte'
    import Menu        from './Menu.svelte'
    import Annotations from './annotations/AnnotationsMenu.svelte'
    import Home        from './pages/Home.svelte'
    import Empresas    from './pages/Empresas.svelte'
    import Users       from './pages/users/Users.svelte'
    import DPOs        from './pages/dpo/DPOs.svelte'
    import Domains     from './pages/domains/Domains.svelte'
    import Cookies     from './pages/cookies/Cookies.svelte'
    import Consent     from './pages/consent/Consent.svelte'
    import Processors  from './pages/processors/Processors.svelte'
    import Policies    from './pages/policies/Policies.svelte'
    import Requests    from './pages/requests/Requests.svelte'
    import Inquiry     from './pages/requests/Inquiry.svelte'
    import Reply       from './pages/requests/Reply.svelte'
    import Places      from './pages/inventory/Places.svelte'
    import Activities  from './pages/activities/Activities.svelte'
    import Profiles    from './pages/profiles/Profiles.svelte'

    export let onLogoff
</script>

<div class="grid" class:dpo={$dpo}>
    <header class="header">
        <TopMenu {onLogoff}/>
    </header>
    <section class="side">
        <Menu {onLogoff}/>
    </section>
    <main class="main">
        <Router>
            <Route path="/empresas"                               component={Empresas}   />
            <Route path="/empresa/:_company"                      component={Home}       />
            <Route path="/empresa/:_company/usuarios"             component={Users}      />
            <Route path="/empresa/:_company/dpos"                 component={DPOs}       />
            <Route path="/empresa/:_company/sites"                component={Domains}    />
            <Route path="/empresa/:_company/politicas/*"          component={Policies}   />
            <Route path="/empresa/:_company/cookies/*"            component={Cookies}    />
            <Route path="/empresa/:_company/consentimentos/*"     component={Consent}    />
            <Route path="/empresa/:_company/operadores"           component={Processors} />
            <Route path="/empresa/:_company/lugares"              component={Places}     />
            <Route path="/empresa/:_company/lugares/:_domain"     component={Places}     />
            <Route path="/empresa/:_company/atividades/:_domain"  component={Activities} />
            <Route path="/empresa/:_company/atividades"           component={Activities} />
            <Route path="/empresa/:_company/perfis"               component={Profiles}   />
            <Route path="/empresa/:_company/perfis/:_domain"      component={Profiles}   />
            <Route path="/empresa/:_company/pedidos"              component={Requests}   />
            <Route path="/empresa/:_company/pedidos/:_domain"     component={Requests}   />
            <Route path="/empresa/:_company/pedidos/:_domain/pedido/:_protocol"                component={Inquiry}  />
            <Route path="/empresa/:_company/pedidos/:_domain/pedido/:_inquiry/enviar/:_source" component={Reply}    />
            <Route component={Home} />
        </Router>
    </main>
</div>
<Annotations></Annotations>